import { useTranslation } from 'react-i18next';
import { useLengthValidationRule } from 'src/shared/hooks/formValidations';

export const useSeoValidationRules = () => {
  const { t } = useTranslation(['validations']);
  const textLength = useLengthValidationRule({ t, max: 10000 });

  return {
    seo_text: [textLength],
  };
};
